module.exports = __webpack_public_path__ + "static/media/badge.14817f53.svg";